module.exports = __webpack_public_path__ + "static/media/Mapa-Ceará.dfd32f67.svg";